import { render, staticRenderFns } from "./ContactNotesSummary.vue?vue&type=template&id=36623204&scoped=true&"
import script from "./ContactNotesSummary.vue?vue&type=script&lang=js&"
export * from "./ContactNotesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36623204",
  null
  
)

export default component.exports